import {
  applyMiddleware,
  createStore as createReduxStore,
  compose
} from 'redux'
import makeRootReducer from './reducers'
import logger from 'redux-logger'
import createSagaMiddleware from 'redux-saga'

// Thêm redux-saga-devtool khi trình duyệt hỗ trợ và trong bản dev
const monitor = window['__SAGA_MONITOR_EXTENSION__']
const sagaMiddleware =
  process.env.NODE_ENV !== 'production' && monitor
    ? createSagaMiddleware({ sagaMonitor: monitor })
    : createSagaMiddleware({})

const createStore = (initState = {}) => {
  //Biến kiểm tra trình duyệt có hỗ trợ redux-devtool không
  const isReduxDevtool =
    typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === 'function'
  const isProduction = process.env.NODE_ENV === 'production'
  const middleware = [sagaMiddleware]

  //Kiểm tra nếu trình duyệt không hỗ trợ redux-devtool thì sử dụng redux-logger
  if (!isReduxDevtool && !isProduction) {
    middleware.push(logger)
  }

  const enhancers = [applyMiddleware(...middleware)]

  let composeEnhancers = compose

  //Setup redux-devtool, nếu trình duyệt hỗ trợ
  if (!isProduction && isReduxDevtool) {
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  }

  const store = createReduxStore(
    makeRootReducer(),
    initState,
    composeEnhancers(...enhancers)
  )

  store.asyncReducers = {}
  store.runSaga = sagaMiddleware.run
  store.injectedSaga = {}

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const reducers = require('./reducers').default
      store.replaceReducer(reducers(store.asyncReducers))
    })
  }
  return store
}

export default createStore
